<div mat-dialog-title class="ds" id="orderTrackingDialogTitle">
  <span id="orderTrackingTitle">{{ appStrings.invoice_trackingTitle }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close id="orderTrackingCloseIconButton">
    <mat-icon class="close-icon" id="orderTrackingCloseIcon">close</mat-icon>
  </button>
</div>
<div id="orderTrackingContainer" mat-dialog-content class="content ds">
  <p id="orderNumber"><b>{{ appStrings.invoice_orderNumber }}:</b> {{ orderNumber }}</p>

  @if (!isMobile) {
    <div class="tables-container" id="orderTrackingTablesContainer">
      <ds-table id="orderTrackingTable" mat-table [dataSource]="trackingNumberList" [displayedColumns]="displayedColumns">
        <ng-container matColumnDef="trackingNumber">
          <th mat-header-cell *matHeaderCellDef id="trackingNumberTitle">
            {{ appStrings.invoice_trackingNumber }}
          </th>
          <td mat-cell *matCellDef="let trackingDetails; let index = dataIndex" [id]="'trackingNumber-' + index">
            @if (trackingDetails.trackingNumber) {
              <span>{{ trackingDetails.trackingNumber }}</span>
            }
            @if (!trackingDetails.trackingNumber) {
              <span>—</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="carrier">
          <th mat-header-cell *matHeaderCellDef id="carrierTitle">
            {{ appStrings.invoice_trackingCarrier }}
          </th>
          <td mat-cell *matCellDef="let trackingDetails; let index = dataIndex" [id]="'carrierName-' + index">
            {{ trackingDetails.carrier }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef id="trackingNumberAction"></th>
          <td mat-cell *matCellDef="let trackingDetails; let index = dataIndex">
            @if (trackingDetails.trackingNumber) {
              <ds-button [id]="'externalLink-' + index" variant="label-icon"
                size="medium" type="primary" (onClick)="openExternalTracking(trackingDetails)" iconPosition="left"
                type="tertiary" icon="open_in_new" [label]="appStrings.invoice_trackButton">
              </ds-button>
            }
          </td>
        </ng-container>
      </ds-table>
      @if (!trackingNumberList.length) {
        <div id="orderTrackingNoTrackingNumbers" class="no-results">
          {{ appStrings.invoice_trackingNoTrackingNumbers }}
        </div>
      }
    </div>
  } @else {
    @for (trackingNumber of trackingNumberList; track trackingNumber; let i = $index) {
      <div class="mobile">
        <mat-expansion-panel [id]="'trackingNumberCard_'+i" class="mobile-card two-columns grey tall" [expanded]="true">
          <div class="content-container">
            <div class="rows-spacing">
              <div class="info-container">
                <typography variant="mat-caption-2" weight="regular" [id]="'trackingNumberLabel_' + i">
                  {{ appStrings.invoice_trackingNumber }}
                </typography>
                <typography variant="mat-caption-1" weight="bold" [id]="'trackingNumberValue_' + i" class="value">
                  {{ trackingNumber.trackingNumber }}
                </typography>
              </div>
              <div class="info-container">
                <typography variant="mat-caption-2" weight="regular" [id]="'trackingCarrierLabel_' + i">
                  {{ appStrings.invoice_trackingCarrier }}
                </typography>
                <typography variant="mat-caption-1" weight="bold" [id]="'trackingCarrierValue_' + i" class="value">
                  {{ trackingNumber.carrier }}
                </typography>
              </div>
            </div>
            <div class="mobile-button-container">
              @if (trackingNumber.trackingNumber) {
                <ds-button [id]="'externalLink-' + i" variant="label-only"
                  size="medium" type="secondary" (onClick)="openExternalTracking(trackingNumber)" [label]="appStrings.invoice_trackButton">
                </ds-button>
              }
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    }
  }

</div>

<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="orderTrackingCloseButton" variant="label-only" size="medium" type="primary" (onClick)="close()"
      [label]="appStrings.button_close">
    </ds-button>
  </div>
</div>
